import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 400,
      fontSize: '12px',
      backgroundColor: palette.background.box,
      borderRadius: '15px',
      boxShadow: palette.shadows.boxShadow,
      padding: '15px',
      flex: 'none',
      height: '500px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      minWidth: '280px'
    },
    empty: {
      backgroundColor: palette.background.dark,
      minWidth: '280px'
    },
    media: {
      padding: 'auto',
      width: '90%',
      alignSelf: 'center',
      height: '200px',
      marginBottom: '0px',
      cursor: 'pointer'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
